var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.threads.markersVisible)?_c('button',{on:{"click":_vm.toggleAll}},[_vm._v("\n  Skrýt všechny komentáře\n")]):_c('button',{on:{"click":_vm.toggleAll}},[_vm._v("Zobrazit všechny komentáře")])}
var staticRenderFns = []

export { render, staticRenderFns }